import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import QuoteTile from 'components/QuoteTile'

const ChainioQuoteTile = () => {
    return (
        <QuoteTile
            backgroundImageStaticQuery={useStaticQuery(graphql`
                query {
                    desktop: file(relativePath: { eq: "customerQuoteTiles/chain-io.png" }) {
                        childImageSharp {
                            fluid(quality: 90, maxWidth: 420) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            `)}
            text={'Enables reporting on Scope 3 emissions across the entire shipment lifecycle'}
            logo={
                <img
                    src="https://assets.lune.co/lune-co/client-logos/chainio.png"
                    alt="Chain-io logo"
                    height={14}
                />
            }
        />
    )
}

export default ChainioQuoteTile
